import { data } from '../../svg/ReplyAll/data';
import { makeIcon } from '../makeIcon';

export const ReplyAll = makeIcon(data, 'reply_all', 'ReplyAll');

export default ReplyAll;
